import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListOrdersComponent } from './components/list-orders/list-orders.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuotesModule } from '../quotes/quotes.module';
import { OrdersFilterComponent } from './components/orders-filter/orders-filter.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { OrderHistoryProductsPreviewComponent } from './components/order-history-products-preview/order-history-products-preview.component';

@NgModule({
  declarations: [
    ListOrdersComponent,
    OrderHistoryComponent,
    OrderHistoryProductsPreviewComponent,
    OrdersFilterComponent,
  ],
  imports: [CommonModule, SharedModule, QuotesModule],
})
export class OrdersModule {}
